import { PdBadgeOrder } from "./pd-badge-order/PdBadgeOrder.js";
//#region src/pd-badge-order/pd-badge-order.ts
var tag = "pd-badge-order";
if (!customElements.get(tag)) customElements.define(tag, PdBadgeOrder);
//#endregion
export { PdBadgeOrder };
